import renderDatetime from '../../../../../../../helpers/tables/render-datetime'
import type { MaterialOrderRequestColumn } from '../../types/column-types'

export const createdAtColumn: MaterialOrderRequestColumn = {
    title: 'Дата создания',
    dataIndex: 'createdAt',
    width: 100,
    render: (v: string) => {
        return v ? renderDatetime(v) : undefined
    },
}
